import {
  Component,
  effect,
  HostListener,
  OnDestroy,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import saveAs from "file-saver";
import * as xlsx from "xlsx";
import { KanbanViewComponent } from "../list-components/kanban-view/kanban-view.component";
import { ListViewComponent } from "../list-components/list-view/list-view.component";
import { CalendarViewComponent } from "../list-components/calendar-view/calendar-view.component";
import { TaskGlobalSettingComponent } from "../task-global-settings/task-global-setting.component";
import { TaskFilterPopupComponent } from "../task-filter-popup/task-filter-popup.component";
import { OnInit } from "@angular/core";
import { GenericFilterRequestDto } from "../../../core/models/generic-filter-request.dto";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { GetAllAssignedUsers } from "../../../core/models/task-management/getAllAssignedUsersDto";
import { GetTaskSwimLanesDto } from "../../../core/models/task-management/getTaskSwimLanesDto";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { TaskTypeEnum } from "../../../shared/enums/taskTypeEnum";
import { EnumSalesTaskStatus } from "../../../shared/enums/salesTaskStatus";
import { WorkflowStatusEnum } from "../../../shared/enums/workflowStatusEnum";
import {
  getColorForName,
  getTextColorForName,
} from "../../../shared/globalfunction";
import { UserManagementService } from "../../../core/services/user-management.service";
import { SharedService } from "../../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import {
  ToggleSwitchChangeEvent,
  ToggleSwitchModule,
} from "primeng/toggleswitch";
import { RadioButtonModule } from "primeng/radiobutton";
import { AvatarModule } from "primeng/avatar";
import { AvatarGroupModule } from "primeng/avatargroup";
import { FormsModule } from "@angular/forms";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { DialogModule } from "primeng/dialog";
import { TaskSidebarComponent } from "../task-sidebar/task-sidebar.component";
import { TaskHeaderComponent } from "../../../shared/components/task-header/task-header.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { AddClientContact } from "../../../core/models/client/addclient/addClientContact";
import { AddContactInformationComponent } from "../../clients/components/add-contact-information/add-contact-information.component";
import { CreateProjectOnTaskComponent } from "../../../modules/task-management/create-project-on-task/create-project-on-task.component";
import { GetAllTaskResponse } from "../../../core/models/task-management/getAllTaskResponseDto";
import { TaskManagementService } from "../../../core/services/task-management.service";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { Popover, PopoverModule } from "primeng/popover";
import { DomSanitizer } from "@angular/platform-browser";
import { MsalApiService } from "../../../core/services/msal-api.service";
import { avatarUserDetailsDto } from "../../../core/models/task-management/avatar-user-details";
import { UserAvatarDetailsComponent } from "../user-avatar-details/user-avatar-details.component";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../orders/components/order-summary/order-summary.component";
import { ProductionWorkflowSummaryComponent } from "../../project-workflow/production-workflow-summary/production-workflow-summary.component";
import { TaskHeaderEditComponent } from "../task-header-edit/task-header-edit.component";
import { InputGroupModule } from "primeng/inputgroup";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";

@Component({
  selector: "jni-task-view-component",
  templateUrl: "./task-view-component.component.html",
  styleUrls: ["./task-view-component.component.scss"],
  imports: [
    ButtonModule,
    CardModule,
    InputTextModule,
    CommonModule,
    ToggleSwitchModule,
    RadioButtonModule,
    AvatarModule,
    AvatarGroupModule,
    FormsModule,
    SelectModule,
    DialogModule,
    TaskSidebarComponent,
    ListViewComponent,
    CalendarViewComponent,
    KanbanViewComponent,
    TaskFilterPopupComponent,
    TaskGlobalSettingComponent,
    SpinnerComponent,
    AddContactInformationComponent,
    CreateProjectOnTaskComponent,
    ConfirmDialogComponent,
    PopoverModule,
    UserAvatarDetailsComponent,
    ModalStackerComponent,
    OrderSummaryComponent,
    ProductionWorkflowSummaryComponent,
    TaskHeaderEditComponent,
    InputGroupModule,
    InputGroupAddonModule,
  ],
})
export class TaskViewComponentComponent implements OnInit, OnDestroy {
  @ViewChild(ListViewComponent) listView!: ListViewComponent;
  @ViewChild(KanbanViewComponent) kanbanView!: KanbanViewComponent;
  @ViewChild(CalendarViewComponent) calendarView!: CalendarViewComponent;
  @ViewChild(TaskGlobalSettingComponent)
  settingView!: TaskGlobalSettingComponent;
  @ViewChild(TaskFilterPopupComponent)
  taskFilterPopup!: TaskFilterPopupComponent;

  @ViewChild("calendarViewComponent", { static: false })
  calendarViewComponent!: CalendarViewComponent;

  @ViewChild("kanbanViewComponent", { static: false })
  kanbanViewComponent!: KanbanViewComponent;

  @ViewChild("taskHeaderEditComponent", { static: false })
  taskHeaderEditComponent!: TaskHeaderEditComponent;

  @ViewChild("listViewComponent", { static: false })
  listViewComponent!: ListViewComponent;

  displayTaskDetailModal = false;
  taskIdSelected = 0;
  displayAddTaskModal = false;
  showTaskModal = false;
  showEditTaskModal = false;
  showSummarykModal = false;
  displaySidebar = false;
  showSmallLoader = false;
  displayFilterModal = false;
  displaySettingModal = false;
  showHideBulkArchiveOption = true;
  viewTypes: { name: string; id: number }[] = [
    { name: "List", id: 1 },
    { name: "Kanban", id: 2 },
    { name: "Calendar", id: 3 },
  ];
  viewSelected: { name: string; id: number } = { name: "List", id: 1 };
  taskType = 0;
  TaskTypeEnum = TaskTypeEnum;
  filterValue!: GenericFilterRequestDto[];
  searchText = "";
  taskView!: number;
  display = false;
  durationTypes: string[] = ["Monthly", "Weekly", "Daily"];
  durationSelected = "Monthly";
  swimLanes: GetTaskSwimLanesDto[] = [];
  displayUsers = false;
  allAssignedUserList: GetAllAssignedUsers[] = [];
  displayClearFilter = false;
  clearColumns = new BehaviorSubject<boolean>(false);
  displayMyTasks = true;
  displayArchivedTasks = false;
  bulkArchive = false;
  isBCUser = false;
  isAdmin = false;
  showAddNewProjectModal = false;
  refreshProjectList = false;
  @ViewChild("taskHeader", { static: false })
  taskHeader!: TaskHeaderComponent;

  @ViewChild("createProjectOnTask", { static: false })
  createProjectOnTask!: CreateProjectOnTaskComponent;

  displayAddContact = false;
  clientId = "";
  buyerName = "";
  addClientContact: AddClientContact = {} as AddClientContact;
  reloadProjects = false;
  showAddTaskSmallLoader = false;

  archiveMessage =
    "You want to <b>archive</b> selected Tasks. <b>Continue</b>?";
  archiveAlertVisible = false;
  bulkArchivedList: GetAllTaskResponse[] = [];
  showUserAvatarDetails = false;
  userAvatorDetails = {} as avatarUserDetailsDto;
  isLoading = false;
  @ViewChild("avatarUserPopover") avatarUserPopover!: Popover;
  currentAvatarTarget: HTMLElement | null = null;
  hideTimeout: ReturnType<typeof setTimeout> | null = null;
  ordersummaryDisplayModal = false;
  salesOrderIdForModal = "";
  orderType = "all-sales";
  showWorkflowSummaryDialog = false;
  workflowId!: number;
  salesOrderId = "";
  headerSearchText = "";

  constructor(
    private route: ActivatedRoute,
    private _loginService: UserManagementService,
    private _taskManagement: TaskManagementService,
    private _domSanitizer: DomSanitizer,
    private _msalApisService: MsalApiService,
    private renderer: Renderer2,
    private _sharedService: SharedService
  ) {
    effect(() => {
      const text = this._sharedService.taskSearchText();
      if (text && text !== this.headerSearchText) {
        this.headerSearchText = text;
        this.searchText = text;
        this.viewSelected = this.viewTypes.find(v => v.id === 3)!;
        this.durationSelected = "Weekly";
        this.displayMyTasks = true;
        this.displayArchivedTasks = false;
        this.filterValue = [];
        this.taskType = 0;
      }
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params["quicktask"]) {
        this.displayAddTaskModal = true;
      }
    });

    const navState = history.state;
    if (navState?.search) {
      this.headerSearchText = "";
      this.viewSelected = this.viewTypes.find(v => v.id === 3)!;
      this.durationSelected = "Weekly";
      this.displayMyTasks = false;
      this.displayArchivedTasks = false;
      this.filterValue = [];
      this.taskType = 0;
    }

    // Duration will be loaded from DB via settings component
    this.getIsBCUser();
  }

  ngOnDestroy() {
    this._sharedService.clearTaskSearchText();
  }

  getIsBCUser() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.isBCUser = res.data.isBCUser;
        this.isAdmin =
          res.data.userRole && res.data.userRole === "Admin" ? true : false;
      });
  }

  redirectToTaskSummary(task: number) {
    this.displayTaskDetailModal = true;
    this.taskIdSelected = task;
  }

  redirectToEditTask(task: number) {
    this.displayAddTaskModal = true;
    this.taskIdSelected = task;
  }

  showDialogSummary() {
    this.showSummarykModal = !this.showSummarykModal;
  }

  closeAddTask(event: {
    added: boolean;
    actionType: "Add" | "Edit";
    hasFormChanged: boolean;
  }) {
    this.displayAddTaskModal = false;
    if (!this.displayTaskDetailModal) {
      this.taskIdSelected = 0;
    } else {
      // this.child.getTaskDetail();
    }
    if (event.added) {
      this.addFilterValues(this.filterValue);
    }
  }

  showAddTask() {
    this.showTaskModal = !this.showTaskModal;
  }

  showEditTask() {
    this.showEditTaskModal = !this.showEditTaskModal;
  }

  showDialog() {
    this.taskIdSelected = 0;
    this.displayAddTaskModal = true;
  }

  showTaskDetailModal() {
    this.displayTaskDetailModal = true;
  }

  closeTaskDetailModal() {
    this.displayTaskDetailModal = false;
  }

  showOrHideSidebar() {
    this.displaySidebar = !this.displaySidebar;
  }

  hideSideBar() {
    this.displaySidebar = false;
  }

  closeFilter() {
    this.displayFilterModal = false;
  }

  closeSetting() {
    this.displaySettingModal = false;
  }

  onViewChange(event: SelectChangeEvent) {
    this.displayMyTasks = true;
    // Only the List view applies the search, so drop it when leaving List
    if (event.value.id !== 1) {
      this.searchText = "";
      this.headerSearchText = "";
    }
    // Disable bulk archive mode when view changes
    // Only reset calendar date if calendar view is available
    if (this.calendarView) {
      this.calendarView.startDate = new Date(); // Reset calendar to current date when duration changes
    }
    if (this.bulkArchive) {
      this.bulkArchive = false;
      this.bulkArchivedList = [];
    }

    if (event.value.id === 2 && this.taskType == 0) {
      const type = 1;
      this.onChangeTaskType({ type, viewType: event.value });
    }

    if (event.value.id === 1) {
      this.showHideBulkArchiveOption = true;
    } else {
      this.showHideBulkArchiveOption = false;
    }
  }

  clearFilters() {
    this.displayClearFilter = false;
    if (this.viewSelected.name === "List") {
      this.clearColumns.next(true);
    }
    this.taskFilterPopup.clearFilters();
    this.addFilterValues([]);
  }

  onChangeTaskType({
    type,
    viewType,
    duration,
  }: {
    type: number;
    viewType?: {
      name: string;
      id: number;
    };
    duration?: string;
  }) {
    this.taskType = type;
    // this.settingView.getSwimLanes(this.taskType);

    // Disable bulk archive mode when task type changes
    if (this.bulkArchive) {
      this.bulkArchive = false;
      this.bulkArchivedList = [];
    }

    if (viewType && !this.headerSearchText) {
      this.viewSelected = viewType;

      if (viewType.id !== 1) {
        this.showHideBulkArchiveOption = false;
      }
    }

    // Update duration if provided from settings
    if (duration && !this.headerSearchText) {
      this.durationSelected = duration;
    }

    if (this.viewSelected.name === "Kanban" && this.kanbanView && type !== 0) {
      this.kanbanView.triggerFunction(this.taskType);
    } else if (this.viewSelected.name === "Calendar" && this.calendarView) {
      this.calendarView.triggerFunction(
        this.filterValue,
        this.taskType,
        this.durationSelected
      );
    } else if (this.viewSelected.name === "List") {
      if (this.listView) {
        this.listView.triggerFunction(this.filterValue, this.taskType);
      }
    }
  }

  onChangeDuration(duration: string) {
    this.displayMyTasks = true;
    this.durationSelected = duration;
    this.calendarView.startDate = new Date(); // Reset calendar to current date when duration changes
    this.calendarView.triggerFunction(
      this.filterValue,
      this.taskType,
      duration
    );
  }

  addFilterValues(globalFilterValue: GenericFilterRequestDto[]) {
    this.filterValue = globalFilterValue;
    this.displayFilterModal = false;
    this.displaySettingModal = false;

    // Disable bulk archive mode when filters are applied
    if (this.bulkArchive && globalFilterValue.length > 0) {
      this.bulkArchive = false;
      this.bulkArchivedList = [];
    }

    if (this.viewSelected.name === "Kanban") {
      this.kanbanView.triggerFunction(0);
    } else if (this.viewSelected.name === "Calendar") {
      this.calendarView.triggerFunction(
        globalFilterValue,
        0,
        this.durationSelected
      );
    } else {
      this.listView.triggerFunction(globalFilterValue);
    }
  }

  receiveAssignedUsers(event: GetAllAssignedUsers[]) {
    this.allAssignedUserList = event;
  }

  get extraUserCount(): number {
    return this.allAssignedUserList.length > 2
      ? this.allAssignedUserList.length - 2
      : 0;
  }

  get remainingAssignedUsers() {
    return this.allAssignedUserList.length > 2
      ? this.allAssignedUserList.slice(2)
      : [];
  }

  getColor(name: string) {
    return getColorForName(name);
  }

  getTextColor(name: string) {
    return getTextColorForName(name);
  }

  toggleUsersList() {
    this.displayUsers = !this.displayUsers;
  }

  getAssignedUserTasks(user: GetAllAssignedUsers) {
    if (this.displayUsers) {
      this.displayUsers = false;
    }
    const keyToCheck = "PersonnelNumber";
    const newValue = user.personalNumber;
    let found = false;

    if (!this.filterValue) {
      this.filterValue = [];
    }

    this.filterValue.forEach((obj: GenericFilterRequestDto) => {
      if (obj.columnName === keyToCheck) {
        obj.value = newValue ?? "";
        found = true;
      }
    });

    if (!found) {
      this.filterValue.push({
        columnName: keyToCheck,
        matchMode: "startsWith",
        tableName: "taskassignments",
        value: newValue,
      } as GenericFilterRequestDto);
    }

    // Disable bulk archive mode when user filter is applied
    if (this.bulkArchive) {
      this.bulkArchive = false;
      this.bulkArchivedList = [];
    }

    this.addFilterValues(this.filterValue);
    this.displayMyTasks = false;
    this.displayClearFilter = true;
  }

  showClearFilter(display: boolean) {
    this.displayClearFilter = display;
  }

  handleTeamTasks(event: ToggleSwitchChangeEvent) {
    this.displayMyTasks = event.checked;

    // Disable bulk archive mode when team tasks toggle changes
    if (this.bulkArchive) {
      this.bulkArchive = false;
      this.bulkArchivedList = [];
    }
  }

  handleArchivedTasks(event: ToggleSwitchChangeEvent) {
    this.displayArchivedTasks = event.checked;
    this.bulkArchive = false;
    this.bulkArchivedList = [];
  }

  bulkArchived(event: ToggleSwitchChangeEvent) {
    this.bulkArchive = event.checked;
    this.displayArchivedTasks = false;
    if (!event.checked) {
      this.bulkArchivedList = [];
    }
  }

  displaySmallLoader(flag: boolean) {
    this.showSmallLoader = flag;
  }

  openAddNewProjectModal() {
    this.createProjectOnTask.clearAddNewProjectModal();
    this.showAddNewProjectModal = true;
  }

  closeAddNewProjectModal() {
    this.showAddNewProjectModal = false;
  }

  refreshProjectGrid(obj: boolean) {
    if (obj === true) {
      this.taskHeader?.getAllProjectsForUsers();
      this.reloadProjects = true;
    }
  }

  populateContactAddedInfo(buyer: string) {
    this.buyerName = buyer;
    if (this.displayAddTaskModal && this.taskHeaderEditComponent) {
      this.taskHeaderEditComponent.popolateBuyerNameAfterContactAdded(buyer);
    } else if (this.viewSelected.id === 3 && this.calendarViewComponent) {
      this.calendarViewComponent.populateContactAddedInfo(buyer);
    } else if (this.viewSelected.id === 2 && this.kanbanViewComponent) {
      this.kanbanViewComponent.populateContactAddedInfo(buyer);
    }
  }

  showContactDialog(client: string) {
    if (client !== "") {
      this.clientId = client;
      this.addClientContact.type = "Buyer";
      this.displayAddContact = true;
    }
  }

  // Helper method to convert task type number to readable text
  private getTaskTypeText(taskType: unknown): string {
    const taskTypeMap: Record<number, string> = {
      [TaskTypeEnum.Sales]: "Sales",
      [TaskTypeEnum.Production]: "Production",
    };
    return taskTypeMap[Number(taskType)] || String(taskType);
  }

  // Helper method to convert status number to readable text
  private getStatusText(status: unknown, taskType: unknown): string {
    const statusNumber = Number(status);
    const type = Number(taskType);

    // Sales task statuses
    const salesStatusMap: Record<number, string> = {
      [EnumSalesTaskStatus.New]: "New",
      [EnumSalesTaskStatus.Blocked]: "Blocked",
      [EnumSalesTaskStatus.InProgress]: "In Progress",
      [EnumSalesTaskStatus.InReview]: "In Review",
      [EnumSalesTaskStatus.Closed]: "Closed",
    };

    // Production task statuses
    const productionStatusMap: Record<number, string> = {
      [WorkflowStatusEnum.ALL]: "All",
      [WorkflowStatusEnum.Cancelled]: "Cancelled",
      [WorkflowStatusEnum.Complete]: "Complete",
      [WorkflowStatusEnum.Delivered]: "Delivered",
      [WorkflowStatusEnum.InProduction]: "In Production",
      [WorkflowStatusEnum.OrderWritten]: "Order Written",
      [WorkflowStatusEnum.PoSent]: "Po Sent",
      [WorkflowStatusEnum.ProjectCreated]: "Project Created",
      [WorkflowStatusEnum.ProofApproved]: "Proof Approved",
      [WorkflowStatusEnum.ProofSent]: "Proof Sent",
      [WorkflowStatusEnum.RevisionRequested]: "Revision Requested",
      [WorkflowStatusEnum.Shipped]: "Shipped",
    };

    // Use appropriate map based on task type
    if (type === TaskTypeEnum.Sales) {
      return salesStatusMap[statusNumber] || String(status);
    } else if (type === TaskTypeEnum.Production) {
      return productionStatusMap[statusNumber] || String(status);
    }

    return String(status);
  }

  // Helper method to strip HTML tags from text
  private stripHtmlTags(html: unknown): string {
    if (!html) return "";
    const text = String(html);
    // Remove HTML tags
    const withoutTags = text.replace(/<[^>]*>/g, "");
    // Decode HTML entities
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = withoutTags;
    return tempDiv.textContent ?? tempDiv.innerText ?? "";
  }

  exportExcel() {
    // Get the task list from the appropriate view component
    const taskList: unknown[] = [];
    let viewName = "Tasks";

    if (this.viewSelected.id === 1 && this.listView) {
      // List View
      const listData = this.listView.taskList || [];
      taskList.push(...listData);
      viewName = "List_View";
    }

    if (!taskList || taskList.length === 0) {
      return;
    }

    // Map the task data to Excel format
    const excelData = taskList.map((task: unknown) => {
      const taskData = task as Record<string, unknown>;
      return {
        ["Task Type"]: this.getTaskTypeText(taskData["taskType"]),
        ["Title"]: taskData["title"] || "",
        ["Description"]: this.stripHtmlTags(taskData["description"]),
        ["Client"]: taskData["client"] || "",
        ["Job Name"]: taskData["jobName"] || "",
        ["Sales Order ID"]: taskData["salesOrderId"] || "",
        ["Project ID"]: taskData["projectWorkflowId"] || "",
        ["Assigned To"]: taskData["assignedTo"] || "",
        ["Owner"]: taskData["owner"] || "",
        ["Due Date"]: taskData["dueDate"] || "",
        ["IHD"]: taskData["ihd"] || "",
        ["ESD"]: taskData["esd"] || "",
        ["Priority"]: taskData["priority"] || "",
        ["Status"]: this.getStatusText(
          taskData["status"],
          taskData["taskType"]
        ),
        ["Notes"]: taskData["notes"] || "",
        ["Created By"]: taskData["createdBy"] || "",
        ["Created Date"]: taskData["createdDate"] || "",
        ["Tags"]: taskData["tags"] || "",
      };
    });

    // Generate Excel file
    const worksheet = xlsx.utils.json_to_sheet(excelData);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    this.saveAsExcelFile(excelBuffer, `Task_Manager_${viewName}`);
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  showOrHideAddTaskSmallLoader($event: boolean) {
    this.showAddTaskSmallLoader = $event;
  }

  handleDisableBulkArchive() {
    this.bulkArchive = false;
    this.bulkArchivedList = [];
  }

  bulkArchiveEvent() {
    this.archiveAlertVisible = true;
  }

  archivedListValues(list: GetAllTaskResponse[]) {
    this.bulkArchivedList = list;
  }

  bulkArchiveConfirmEvent(event: boolean) {
    if (event) {
      const archivedIds = this.bulkArchivedList.map(({ taskId }) => taskId);
      const payload = {
        taskIds: archivedIds,
      };
      this.showSmallLoader = true;
      this._taskManagement.MarkAsBulkArchive(payload).subscribe({
        next: async res => {
          if (res && res.status.toLowerCase() === "success") {
            this.listView.triggerFunction(this.filterValue, this.taskType);
            this.bulkArchivedList = [];
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
    }
    this.archiveAlertVisible = false;
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const avatarGroup = target.closest(".avatar-group");

    if (!avatarGroup && this.displayUsers) {
      this.displayUsers = false;
    }
  }

  showAvatarPopover(event: MouseEvent, user: GetAllAssignedUsers): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    const newTarget = event.currentTarget as HTMLElement;

    // If we're switching to a different target and popover is already visible, hide it first
    if (
      this.currentAvatarTarget &&
      this.currentAvatarTarget !== newTarget &&
      this.avatarUserPopover
    ) {
      this.avatarUserPopover.hide();
      // Add a small delay to ensure the popover is fully hidden before showing on new target
      setTimeout(() => {
        this.currentAvatarTarget = newTarget;
        this.showUserAvatarDetails = true;
        this.getTooltipContent(user);

        setTimeout(() => {
          if (this.avatarUserPopover && this.currentAvatarTarget) {
            this.avatarUserPopover.show(event, this.currentAvatarTarget);
          }
        }, 100);
      }, 50);
    } else {
      this.currentAvatarTarget = newTarget;
      // First set up the content
      this.showUserAvatarDetails = true;
      this.getTooltipContent(user);

      // Wait a short moment for the content to be rendered, then show popover
      setTimeout(() => {
        if (this.avatarUserPopover && this.currentAvatarTarget) {
          this.avatarUserPopover.show(event, this.currentAvatarTarget);
        }
      }, 100);
    }
  }

  hideAvatarPopover(): void {
    this.hideTimeout = setTimeout(() => {
      if (this.avatarUserPopover) {
        this.avatarUserPopover.hide();
      }
      this.onAvatarLeave();
    }, 200);
  }

  keepPopoverOpen(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  getTooltipContent(obj: GetAllAssignedUsers) {
    this.userAvatorDetails.name = obj.name ?? "";
    this.userAvatorDetails.email = obj.loginEmail ?? "";
    this.userAvatorDetails.personalNumber = obj.personalNumber ?? "";
    this.userAvatorDetails.locationName = obj.locationName ?? "";
    this.fetchUserProfile(obj.loginEmail ?? "");
    this.showUserAvatarDetails = true;
  }

  onAvatarLeave() {
    this.clearAvatarDetails();
    this.showUserAvatarDetails = false;
    this.currentAvatarTarget = null;
  }

  clearAvatarDetails() {
    this.userAvatorDetails = {} as avatarUserDetailsDto;
  }

  fetchUserProfile(loginEmail: string): void {
    this.isLoading = true;
    this._msalApisService.getUserProfilePicture(loginEmail).subscribe({
      next: (res: Blob) => {
        const urlCreator = window.URL || window.webkitURL;
        this.userAvatorDetails.profileImageUrl =
          this._domSanitizer.bypassSecurityTrustUrl(
            urlCreator.createObjectURL(res)
          );
        this.isLoading = false;
      },
      error: () => {
        this.userAvatorDetails.profileImageUrl =
          "../../../assets/images/avatar-default.webp";
        this.isLoading = false;
      },
    });
  }

  showOrderSummaryModal(salesOrderId: string) {
    this.salesOrderIdForModal = salesOrderId;
    this.ordersummaryDisplayModal = true;
  }

  closeModalForSaleOrderSummary() {
    this.ordersummaryDisplayModal = false;
  }

  showWorkflowSummaryModal(data: { salesOrderId: string; workflowId: number }) {
    this.salesOrderId = data.salesOrderId;
    this.workflowId = data.workflowId;
    this.showWorkflowSummaryDialog = true;
  }

  closeWorkflowSummaryModal() {
    this.showWorkflowSummaryDialog = false;
  }

  handleTaskHeaderWorkflowSummary(data: {
    salesOrderId: string;
    workflowId: number;
  }) {
    this.showWorkflowSummaryModal(data);
  }

  handleTaskHeaderOrderSummary(salesOrderId: string) {
    this.showOrderSummaryModal(salesOrderId);
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  onSubmit() {
    const text = this.searchText.trim();
    if (this.viewSelected.id !== 1) {
      if (!text) {
        return;
      }
      // The new List view loads with headerSearchText via its @Input
      this.headerSearchText = text;
      this.viewSelected = this.viewTypes.find(v => v.id === 1)!;
      this.showHideBulkArchiveOption = true;
      return;
    }
    this.headerSearchText = text;
    if (this.listView) {
      this.listView.triggerSearch(this.headerSearchText);
    }
  }

  clearSearchFilter() {
    this.headerSearchText = "";
    this.searchText = "";
    this._sharedService.clearTaskSearchText();
    if (this.viewSelected.name === "Calendar" && this.calendarView) {
      this.calendarView.searchText = "";
      this.calendarView.triggerFunction(
        this.filterValue,
        this.taskType,
        this.durationSelected
      );
    } else if (this.viewSelected.name === "List" && this.listView) {
      this.listView.triggerSearch("");
    } else if (this.viewSelected.name === "Kanban" && this.kanbanView) {
      this.kanbanView.headerSearchText = "";
      this.kanbanView.triggerFunction(this.taskType);
    }
  }

  onClearSearchClick() {
    this.clearSearchFilter();
  }

  // List view only: restore unfiltered results the moment the box is backspaced/cleared to empty
  onSearchTextChange(value: string) {
    if (this.viewSelected.id === 1 && !value?.trim() && this.headerSearchText) {
      this.clearSearchFilter();
    }
  }
}
